<template>
    <div></div>
</template>

<script>
import BelowInfoPanel from './BelowInfoPanel.js';
export default BelowInfoPanel;
</script>
